import { render, staticRenderFns } from "./factura_proveedor.vue?vue&type=template&id=0d483012&"
import script from "./factura_proveedor.vue?vue&type=script&lang=js&"
export * from "./factura_proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports